// extracted by mini-css-extract-plugin
module.exports = {"Chat":"Chat_Chat__2RLmM","LeftSection":"Chat_LeftSection__-y-xs","RightSection":"Chat_RightSection__1qimL"};